export default [
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `"Yes, latte, please. Thank you."`,
        speakerTxtRS: `"Da, latte, molim te. Hvala."`,
        dialogFx: `assets/dialog/joseph/joseph0034.mp3`,
        choicesBtns: `unset`
    },
    {
        speakerName: `unset`,
        characterImg: `unset`,
        speakerTxt: `[10 minutes later ...]`,
        speakerTxtRS: `[10 minuta kasnije ...]`
    },
    {
        speakerName: `Anna Adams `,
        speakerNameRS: `Ana Adamović`,
        characterImg: `assets/chars/anna/closedEyesSmile.webp`,
        speakerTxt: `"Here you go. Enjoy your latte!"`,
        speakerTxtRS: `"Izvoli. Uživaj u svom latteu!"`,
        dialogFx: `assets/dialog/anna/anna0007.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        characterImg: `assets/chars/anna/closedSmile.webp`,
        speakerTxt: `"Thanks, it looks delicious!"`,
        speakerTxtRS: `"Hvala, izgleda ukusno!"`,
        dialogFx: `assets/dialog/joseph/joseph0035.mp3`
    },
    {
        speakerName: `Anna Adams `,
        speakerNameRS: `Ana Adamović`,
        speakerTxt: `"Glad you like it. Is there anything else I can get for you?"`,
        speakerTxtRS: `"Srećna sam što ti se sviđa. Je li ima još nešto što mogu da ti donesem?"`,
        dialogFx: `assets/dialog/anna/anna0008.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `"No, this is perfect. Thanks again!"`,
        speakerTxtRS: `"Ne, ovo je savršeno. Hvala ti opet!"`,
        dialogFx: `assets/dialog/joseph/joseph0036.mp3`
    },
    {
        speakerName: `Anna Adams `,
        speakerNameRS: `Ana Adamović`,
        speakerTxt: `"You're welcome."`,
        speakerTxtRS: `"Nema na čemu."`,
        dialogFx: `assets/dialog/anna/anna0009.mp3`
    }
]